import styled from 'styled-components'
import * as React from 'react'
import { Table, TableCell, TableBody, TableRow } from '@mui/material';


export const ConditionTable = styled(Table)`
 &.MuiTableCell-root {
   padding: 2px 12px 2px 12px;
 }
`;

export const ConditionTableBody = styled(TableBody)`

`;
export const ConditionTableRow = styled(TableRow)``;


export const ConditionCategoryCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  font-weight: bold;
  font-size: 1rem;
  line-height: 2.3em;
  vertical-align: top;
  white-space: nowrap;
  padding: 2px 12px 2px 12px;
  }
`;

export const ConditionColumNameCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  white-space: nowrap;
  vertical-align: top;
  line-height: 2.5em;
  padding: 2px 12px 2px 12px;
  }
`;

export const ConditionInputCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  line-height: 2.5em;
  padding: 2px 12px 2px 12px;
  white-space: nowrap;
  width: 100%;
  }

  .MuiCheckbox-root,.MuiRadio-root {
  padding: 2px;
  }
`;

export const ConditionInputCellForColgroup = styled(ConditionInputCell)`
 &.MuiTableCell-root {
 width: initial;
 }
`;

export const ConditionButtonCell = styled(TableCell)`
 &.MuiTableCell-root {
  border-bottom: none;
  text-align: right;
  white-space: nowrap;
  line-height: 2.5em;
  padding: 2px 12px 2px 12px;
  }
`;


export const ConditionTableFixed = styled(ConditionTable)`
 &.MuiTable-root {
   table-layout: fixed;
 }
`;

export const ConditionCategoryCellFixed = styled(ConditionCategoryCell)`
 &.MuiTableCell-root {
   width: 10%;
  }
`;

export const ConditionColumNameCellFixed = styled(ConditionColumNameCell)`
 &.MuiTableCell-root {
   width: 15%;
  }
`;

